import React, { useEffect, useState } from "react";
import { sortObjectsByAlphabet } from "../../utils";
import SelectV2 from "../../view/SelectV2";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function MsbField({ value, msbList, onChange, error, disabled }) {

    useEffect(() => {
        validationService.validateNotEmpty(value, 'msb');
        return () => validationService.cleanValidation('msb');
    }, [value]);

    const [touched, setTouched] = useState(false);

    const handleChange = (id) => {
        const msb = msbList.find((msb) => String(msb.id) === String(id));
        onChange(msb);
        setTouched(true);
    };

    const msbListCopy = sortObjectsByAlphabet(msbList, 'name');
    const msbOptions = msbListCopy.map((msb) => ({
        value: msb.id,
        label: msb.name
    }));

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="msb">Minimum Security Baseline <span className="modal-v2-required-mark">*</span></label>
                <SelectV2
                    inputId="msb"
                    className={(error && touched) ? "border-danger" : ""}
                    value={value ?? ""}
                    onChange={handleChange}
                    options={msbOptions}
                    isDisabled={disabled || msbOptions.length === 0}
                    placeholder="Select MSB"
                    noOptionsMessage={() => "No MSBs found"}
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    debug("MsbField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.msb
    };
}

export default connect(mapStateToProps)(MsbField);
